import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, ShieldCheck } from "lucide-react";
import myImage from "../assets/logo/dl.webp";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [subscribed, setSubscribed] = useState(false);

  const handleSubscribe = (e: React.FormEvent) => {
    e.preventDefault();
    if (email.trim()) {
      setSubscribed(true);
      setEmail("");
      setTimeout(() => setSubscribed(false), 4000);
    }
  };

  return (
    <footer className="bg-slate-100 dark:bg-[#030712] border-t border-slate-200 dark:border-white/10 text-slate-700 dark:text-slate-400 font-body relative overflow-hidden pt-16 pb-12 transition-colors duration-300">
      {/* Background glow gradient */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-3/4 h-32 bg-blue-500/10 dark:bg-blue-600/10 blur-[120px] pointer-events-none" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10 pb-12 border-b border-slate-200 dark:border-white/10">
          
          {/* BRAND SUMMARY */}
          <div className="lg:col-span-2 space-y-5">
            <Link to="/" className="flex items-center gap-3">
              <div className="p-1.5 rounded-xl bg-white dark:bg-gradient-to-r dark:from-blue-600/30 dark:to-violet-600/30 border border-slate-200 dark:border-white/10 shadow-xs">
                <img src={myImage} alt="Hickter Logo" className="h-8 object-contain" />
              </div>
            </Link>

            <p className="text-slate-600 dark:text-slate-400 text-sm leading-relaxed max-w-md font-medium">
              Hickter Technology Solutions is a forward-thinking company engineered to solve complex digital challenges. We help businesses scale through modern websites, mobile apps, and smart digital marketing.
            </p>

            <div className="flex items-center gap-3 pt-2">
              <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold bg-emerald-50 dark:bg-emerald-500/10 text-emerald-700 dark:text-emerald-400 border border-emerald-200 dark:border-emerald-500/20">
                <span className="w-2 h-2 rounded-full bg-emerald-500 dark:bg-emerald-400 animate-pulse" />
                24/7 Support Active
              </span>
              <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold bg-blue-50 dark:bg-blue-500/10 text-blue-700 dark:text-blue-400 border border-blue-200 dark:border-blue-500/20">
                <ShieldCheck size={12} /> High Performance
              </span>
            </div>
          </div>

          {/* QUICK LINKS */}
          <div className="space-y-4">
            <h4 className="font-heading text-sm font-bold uppercase tracking-wider text-slate-900 dark:text-white">Navigation</h4>
            <ul className="space-y-2.5 text-sm font-medium">
              <li><Link to="/" className="nav-link-item hover:text-blue-600 dark:hover:text-blue-400 transition-colors">Home</Link></li>
              <li><Link to="/about" className="nav-link-item hover:text-blue-600 dark:hover:text-blue-400 transition-colors">About Us</Link></li>
              <li><Link to="/services" className="nav-link-item hover:text-blue-600 dark:hover:text-blue-400 transition-colors">Services</Link></li>
              <li><Link to="/ourproducts/our-products-all" className="nav-link-item hover:text-blue-600 dark:hover:text-blue-400 transition-colors">Our Products</Link></li>
              <li><Link to="/Portfolio" className="nav-link-item hover:text-blue-600 dark:hover:text-blue-400 transition-colors">Portfolio</Link></li>
              <li><Link to="/Pricing" className="nav-link-item hover:text-blue-600 dark:hover:text-blue-400 transition-colors">Pricing</Link></li>
            </ul>
          </div>

          {/* SERVICES & SOLUTIONS */}
          <div className="space-y-4">
            <h4 className="font-heading text-sm font-bold uppercase tracking-wider text-slate-900 dark:text-white">Solutions</h4>
            <ul className="space-y-2.5 text-sm font-medium">
              <li><Link to="/services" className="nav-link-item hover:text-blue-600 dark:hover:text-blue-400 transition-colors">Website Development</Link></li>
              <li><Link to="/services" className="nav-link-item hover:text-blue-600 dark:hover:text-blue-400 transition-colors">Mobile App Engineering</Link></li>
              <li><Link to="/services" className="nav-link-item hover:text-blue-600 dark:hover:text-blue-400 transition-colors">Digital Growth Marketing</Link></li>
              <li><Link to="/tracknn" className="nav-link-item hover:text-blue-600 dark:hover:text-blue-400 transition-colors">Client Project Status</Link></li>
              <li><Link to="/Meeting" className="nav-link-item hover:text-blue-600 dark:hover:text-blue-400 transition-colors">Book Consultation</Link></li>
              <li><Link to="/enquirynow" className="nav-link-item hover:text-blue-600 dark:hover:text-blue-400 transition-colors">Instant Project Enquiry</Link></li>
            </ul>
          </div>

          {/* NEWSLETTER / CONTACT */}
          <div className="space-y-4">
            <h4 className="font-heading text-sm font-bold uppercase tracking-wider text-slate-900 dark:text-white">Connect</h4>
            <p className="text-xs text-slate-600 dark:text-slate-400 font-medium">Subscribe for technical insights & digital growth updates.</p>

            <form onSubmit={handleSubscribe} className="space-y-2">
              <div className="relative flex items-center gap-2">
                <input
                  type="email"
                  placeholder="Enter work email..."
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full text-xs bg-white dark:bg-slate-950 border border-slate-300 dark:border-slate-700 text-slate-900 dark:text-white rounded-xl py-2.5 pl-3 pr-10 focus:border-blue-600 shadow-xs"
                  required
                />
                <button type="submit" className="btn-primary-blue h-9 px-3 rounded-lg flex items-center justify-center shrink-0 cursor-pointer">
                  <ArrowRight size={14} />
                </button>
              </div>
              {subscribed && (
                <p className="text-[11px] text-emerald-600 dark:text-emerald-400 font-semibold">Thank you for subscribing!</p>
              )}
            </form>

            <div className="space-y-1.5 text-xs pt-2 text-slate-600 dark:text-slate-400 font-medium">
              <p>Email: <a href="mailto:contact@hickter.com" className="action-link text-blue-600 dark:text-blue-400 hover:underline">contact@hickter.com</a></p>
              <p>Website: <a href="https://hickter.com" target="_blank" rel="noreferrer" className="action-link text-blue-600 dark:text-blue-400 hover:underline">hickter.com</a></p>
            </div>
          </div>

        </div>

        {/* COPYRIGHT & FOOTER LINKS */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 pt-8 text-xs text-slate-500 dark:text-slate-400 font-medium">
          <p>© {new Date().getFullYear()} Hickter Technology Solutions. All rights reserved.</p>
          <div className="flex items-center gap-6">
            <Link to="/PrivacyPolicy" className="nav-link-item hover:text-blue-600 dark:hover:text-blue-400 transition-colors">Privacy Policy</Link>
            <Link to="/TermsOfService" className="nav-link-item hover:text-blue-600 dark:hover:text-blue-400 transition-colors">Terms of Service</Link>
            <Link to="/Refundpolicy" className="nav-link-item hover:text-blue-600 dark:hover:text-blue-400 transition-colors">Refund Policy</Link>
          </div>
        </div>

      </div>
    </footer>
  );
}
